import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ListItem from '@material-ui/core/ListItem';
import {
    Input,
    IconButton,
    Icon
} from 'components';
import styles from './CardOption.scss';

/**
 * this component is a class component because is used inside
 * react-draggable-list  https://github.com/StreakYC/react-draggable-list
 * and they ask for those components to be class components.
*/
class CardOption extends Component {
    handleDelete = () => {
        const { item, commonProps: { onDelete } } = this.props;
        onDelete(item);
    }

    handleEdit = (event) => {
        const { item, commonProps: { onEdit } } = this.props;
        onEdit(event.target.value, item);
    }

    render () {
        const {
            commonProps: {
                disabled,
                placeholder
            },
            dragHandleProps,
            item
        } = this.props;

        return (
            <ListItem className={classnames(styles.cardOption, { [styles.disabled]: disabled })}>
                <Input
                    placeholder={placeholder}
                    inputProps={{'aria-label': item.display || placeholder}}
                    disabled={disabled}
                    value={item.display}
                    disableUnderline
                    fullWidth
                    onChange={this.handleEdit}
                    autoFocus
                    endAdornment={
                        <div className={styles.iconsContainer}>
                            <IconButton
                                disabled={disabled}
                                onClick={this.handleDelete}
                                className={styles.deleteIcon}
                                color='secondary'
                            >
                                <Icon name='ion-md-trash'/>
                            </IconButton>

                            <IconButton
                                disabled={disabled}
                                className={styles.dragHandle}
                                {...dragHandleProps}
                            >
                                <Icon name='ion-md-menu'/>
                            </IconButton>
                        </div>
                    }
                />
            </ListItem>
        );
    }
}

CardOption.propTypes = {
    commonProps: PropTypes.shape({
        onEdit: PropTypes.func.isRequired,
        onDelete: PropTypes.func.isRequired,
        disabled: PropTypes.bool.isRequired,
        placeholder: PropTypes.string
    }).isRequired,
    dragHandleProps: PropTypes.object.isRequired,
    item: PropTypes.shape({
        display: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired
    }).isRequired
};

export default CardOption;
